import { ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Token } from "../theme";

interface Props {
  primaryText?: string;
  secondaryText?: string;
  icon?: JSX.Element;
  action?: JSX.Element;
  truncate?: boolean;
}

const PrimaryLabel = ({ primaryText, action }: Partial<Props>) => {
  const classes = useStyles();

  return action ? (
    <span className={classes.primaryRow}>
      {primaryText}
      {action}
    </span>
  ) : (
    <>{primaryText}</>
  );
};

export const AppListItem = ({ primaryText, secondaryText, icon, action }: Props) => {
  const classes = useStyles();
  return (
    <ListItem className={classes.row}>
      {icon && <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>}
      <ListItemText
        className={classes.listItem}
        primary={<PrimaryLabel primaryText={primaryText} action={action} />}
        secondary={secondaryText}
      />
    </ListItem>
  );
};

const useStyles = makeStyles(
  () => ({
    row: {
      paddingLeft: 0,
      paddingTop: 6,
      paddingBottom: 6,
      alignItems: "flex-start",
    },
    icon: {
      minWidth: 32,
      marginTop: 2,
      color: Token.textTertiary,
    },
    listItem: {
      margin: 0,
      "&> span": {
        color: Token.textTertiary,
        fontSize: "10.5px",
        textTransform: "uppercase",
        letterSpacing: ".08em",
        fontWeight: 600,
        lineHeight: 1.4,
      },
      "&> p": {
        color: Token.textPrimary,
        fontSize: "13px",
        lineHeight: 1.4,
      },
    },
    primaryRow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
    },
  }),
  { index: 1 },
);
